/**
 * Talep bilgileri ile ilgili yardımcı fonksiyonlar.
 * Toplu Haciz, Tebligat ve Diğer Talep handler'larında ortak kullanım.
 */

/**
 * Talep bilgilerinden "Talep Adı (adet)" formatında string oluşturur.
 * Koşulları sağlanarak gönderilen talepleri özetler.
 * @example getGonderilenTaleplerStr([{talepAdi: "Araç Haczi", ...}, {talepAdi: "Araç Haczi", ...}]) => "Araç Haczi Talebi (2)"
 */
export function getGonderilenTaleplerStr(talepBilgileri: any[]): string {
    const sayac: Record<string, number> = {};
    talepBilgileri.forEach((t) => {
        const ad = t.talepAdi || t.talepKisaAdi;
        if (ad) sayac[ad] = (sayac[ad] || 0) + 1;
    });
    return Object.entries(sayac)
        .map(([ad, n]) => `${ad} (${n})`)
        .join(', ');
}
